// RequireLogin.js — 로그인이 필요한 화면을 감싸는 라우트 가드 (로그인 후 원래 화면으로 돌아온다)
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  return !!token && !!localStorage.getItem('userId') && isTokenValid(token);
};

export default function RequireLogin({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const authed = isLoggedIn();

  useEffect(() => {
    if (!authed) {
      navigate('/login', { replace: true, state: { from: location.pathname + location.search, required: true } });
    }
  }, [authed, navigate, location]);

  return authed ? children : null;
}
